import { createContext, useContext } from "react";

export interface SheetMeta {
  /**
   * @param string Unique identifier for the sheet.
   */
  id: string;
  /**
   * @param boolean Whether the sheet is collapsed when it is the second-last sheet in the stack, i.e. behind the front sheet. Defaults to `true`.
   */
  isCollapsed: boolean;
}

export const SheetContainerContext = createContext<{
  sheets: SheetMeta[];
  register: (id: string, isCollapsed: boolean) => void;
  unregister: (id: string) => void;
  setIsCollapsed: (id: string, isCollapsed: boolean) => void;
  enableTransitions: boolean;
}>({
  sheets: [],
  register: () => {},
  unregister: () => {},
  setIsCollapsed: () => {},
  enableTransitions: false
});

export function useSheetContainerContext() {
  return useContext(SheetContainerContext);
}
